import { render, staticRenderFns } from "./ActivatePermissionAPIPopup.vue?vue&type=template&id=f06e798c"
import script from "./ActivatePermissionAPIPopup.vue?vue&type=script&lang=js"
export * from "./ActivatePermissionAPIPopup.vue?vue&type=script&lang=js"
import style0 from "./ActivatePermissionAPIPopup.vue?vue&type=style&index=0&id=f06e798c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports